const browsTrActionList = [
  {
    text: 'Apply Fee',
    value: 1,
  },
  {
    text: 'Apply Mortgage Code',
    value: 2,
  },
  {
    text: 'Add Status Code',
    value: 3,
  },
  {
    text: 'Set Penalty Start Date',
    value: 4,
  },
  {
    text: 'Add Comment',
    value: 5,
  },
  {
    text: 'Add All Delinquent Records Associated With Records in List',
    value: 6,
  },
  {
    text: 'Remove Fee',
    value: 7,
  },
  {
    text: 'Remove Mortgage Code',
    value: 8,
  },
  {
    text: 'Remove Status Code',
    value: 9,
  },
  {
    text: 'Remove Paid Records',
    value: 10,
  },
  {
    text: 'Remove overpaid Records',
    value: 15,
  },
  {
    text: 'Remove Penalty Start Date',
    value: 11,
  },
  {
    text: 'Add Personal Tax Warrant',
    value: 12,
  },
  {
    text: 'Create Resale List',
    value: 13,
  },
  {
    text: 'Apply Cert Numbers',
    value: 14,
  },
];
export { browsTrActionList };
export default {};
